module.exports = __webpack_public_path__ + "img/games-together-alone-alpha.a0afa4ac.png";